import {
    SpacingToken,
    UiStack,
} from '@experiences/ui-common';
import { RadioGroup } from '@mui/material';
import React, { useCallback } from 'react';

interface UiRadioCardGroupProps {
    direction?: 'row' | 'column';
    selectedMode: any;
    onModeChange: (mode: any) => void;
    dataCyPrefix?: string;
    width?: number | string;
    children: React.ReactNode;
}

export const UiRadioCardGroup: React.FC<UiRadioCardGroupProps> = ({
    direction = 'column',
    selectedMode,
    onModeChange,
    dataCyPrefix = 'ui-radio-card-group',
    width,
    children,
}) => {
    const handleModeChange = useCallback((value: string) => {
        onModeChange?.(value);
    }, [ onModeChange ]);

    return (
        <RadioGroup
            value={selectedMode}
            onChange={(e) => handleModeChange(e.target.value)}
            data-cy={`${dataCyPrefix}-radio-group`}
        >
            <UiStack
                direction={direction}
                gap={SpacingToken.M}
                flex={1}
                {...(width && { w: width })}
                data-cy={`${dataCyPrefix}-cards`}
            >
                {children}
            </UiStack>
        </RadioGroup>
    );
};
